function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.833374 2.6665C0.833374 2.11422 1.28109 1.6665 1.83337 1.6665H18.1667C18.719 1.6665 19.1667 2.11422 19.1667 2.6665V2.70354C19.1667 3.25583 18.719 3.70354 18.1667 3.70354H1.83338C1.28109 3.70354 0.833374 3.25583 0.833374 2.70354V2.6665ZM0.833374 9.79613C0.833374 9.24385 1.28109 8.79613 1.83337 8.79613H18.1667C18.719 8.79613 19.1667 9.24385 19.1667 9.79613V9.83317C19.1667 10.3855 18.719 10.8332 18.1667 10.8332H1.83338C1.28109 10.8332 0.833374 10.3855 0.833374 9.83317V9.79613ZM0.833374 16.9258C0.833374 16.3735 1.28109 15.9258 1.83337 15.9258H18.1667C18.719 15.9258 19.1667 16.3735 19.1667 16.9258V16.9628C19.1667 17.5151 18.719 17.9628 18.1667 17.9628H1.83338C1.28109 17.9628 0.833374 17.5151 0.833374 16.9628V16.9258Z"
});

function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.df6f9255.svg";
export { ForwardRef as ReactComponent };